import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';

class NewEventPopup extends Component {
  constructor() {
    super();
    this.add_new_event = this.save_new_event_data.bind(this);
    this.state = {
      send_button : <button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_new_event}>Save</button>,
      view_email_list:[],
    };
  }
get_all_user_email(){
  var cutThis        = this;
  var web_token     = window.isNullAndUndef($('#web_token').val());
  var body          = new FormData();
  body.append('web_token',web_token);
  body.append('function','get_all_email_id');
  var url      = '';
  if(window.location.host ==="localhost:3000"){
    url = "http://localhost/bylawsindia/php/admin_event_manage_url.php";
  }else{
    url = "/php/admin_event_manage_url.php";
  }
  axios({
       method: 'POST',
       url: url,
       async: false,
       data: body,
       enctype: 'multipart/form-data',
       processData: false,
       contentType: false,
       cache: false,
   })
   .then(function (res) {
      var data = res.data;
      cutThis.search_email_in_db(data);
   })
   .catch(function (error) {
       console.log(error);
   });
}
componentDidMount(){
  const emailInput = document.getElementById('emailInputContainer');
  //adds the click event listener to the input container
  emailInput.addEventListener('click', (event)=>{
    const target = event.currentTarget;
    const newInput = window.createNewInput();
    target.append(newInput);
    newInput.focus();
  });
  this.get_all_user_email();

}
save_new_event_data(){
  var cutThis               = this;
  var event_title           = window.isNullAndUndef($('#event_title').val());
  var envet_from_date       = window.isNullAndUndef($('#envet_from_date').val());
  var envet_from_time       = window.isNullAndUndef($('#envet_from_time').val());
  var envet_to_date         = window.isNullAndUndef($('#envet_to_date').val());
  var envet_to_time         = window.isNullAndUndef($('#envet_to_time').val());
  var envet_message         = window.isNullAndUndef($('#envet_message').val());
  var envet_file            = window.isNullAndUndef($('#envet_file').val());
  var envet_file_tmp        = $('#envet_file').val();
  var web_token             = window.isNullAndUndef($('#web_token').val());

  var paragraphTexts = [];
  $('#emailInputContainer > span').each(function() {
    paragraphTexts.push($(this).text());
  });
  var envet_agenda_file       = '';
  var envet_agenda_file_ext   = '';
  var envet_agenda_file_name  = '';
  var agenda_flag             = 0;
  if(envet_file){
    var file_main_ext         = ['pdf','PDF','png','jpg','jpeg','JPEG','JPG','PNG'];
    var envet_agenda_file     = $("#envet_file").prop("files")[0];
    envet_agenda_file_ext     = envet_file.split('.').pop();
    envet_agenda_file_name    = $('#envet_file').val().split('\\').pop();
    if(file_main_ext.indexOf(envet_agenda_file_ext) >= 0){agenda_flag = 0;}else{agenda_flag = 1;}
  }
  var send_button     = <button className="btn btn-primary w-100 py-3" type="button">Save</button>;
  cutThis.setState({send_button});


  if(event_title && envet_from_date && envet_from_time && envet_to_date && envet_to_time && envet_message && paragraphTexts.length>0 && agenda_flag==0){

    var all_data                  = {};
    all_data['event_title']       = window.return_false_null(event_title);
    all_data['envet_from_date']   = window.return_false_null(envet_from_date);
    all_data['envet_from_time']   = window.return_false_null(envet_from_time);
    all_data['envet_to_date']     = window.return_false_null(envet_to_date);
    all_data['envet_to_time']     = window.return_false_null(envet_to_time);
    all_data['envet_message']     = window.return_false_null(envet_message);
    all_data['agenda_file_name']  = window.return_false_null(envet_agenda_file_name);
    all_data['email_list']        = paragraphTexts;

    var body = new FormData();
    body.append('envet_agenda_file',envet_agenda_file);
    body.append('event_date',JSON.stringify(all_data));
    body.append('web_token',web_token);
    body.append('agenda_flag',agenda_flag);
    body.append('envet_file_tmp',envet_file_tmp);
    body.append('function','add_event_basic_details');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_event_manage_url.php";
    }else{
      url = "/php/admin_event_manage_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         async: false,
         data: body,
         enctype: 'multipart/form-data',
         processData: false,
         contentType: false,
         cache: false,
     })
     .then(function (res) {
        var data = res.data
        if(data['error']!=0){
          $('#error_msg').text(data['msg']);
          send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.props.close_popup_view}>Close</button>;
          cutThis.setState({send_button});
        }else{
          $('#error_msg').text('Error - 400');
          send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.save_new_event_data.bind(cutThis)}>Save</button>;
          cutThis.setState({send_button});
        }

     })
     .catch(function (error) {
         console.log(error);
     });

  }else{
    window.change_lable_color('event_title','envet_from_date','envet_from_time','envet_to_date','envet_to_time','envet_message');
    if(paragraphTexts.length>0){$('#attendees_label').removeClass('color_red');}else {$('#attendees_label').addClass('color_red');}
    if(agenda_flag==1){$('#envet_file').next('label').addClass('color_red');}else if(envet_file && agenda_flag==0){window.change_lable_color('envet_file');}
    send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.save_new_event_data.bind(cutThis)}>Save</button>;
    cutThis.setState({send_button});
  }
}

search_email_in_db(data){
  var view_email_list = window.get_input_email_val(data);
  this.setState({view_email_list});
}

  render() {
    return (
        <>
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog popup_view_width">
            <div className="modal-content">
              <div className="modal-header">
              <h4 className="modal-title" id="page_titlte">New Event</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div className="modal-body">


              <div className="">
              <div className="col-md-12">
                  <div className="wow fadeInUp" data-wow-delay="0.5s">
                      <form action="" method="post">
                          <div className="row g-3">

                              <div className="col-md-12">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="event_title" placeholder="Event Title"/>
                                      <label for="name">Event Title</label>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="form-floating">
                                      <label for="name" className="email_lable" id="attendees_label">Invite Attendees</label>
                                      <div id="emailInputContainer" className="form-control" tabindex="0"></div>
                                      <ul id="search_list" className="hide" dangerouslySetInnerHTML={{ __html: this.state.view_email_list }}></ul>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-floating">
                                      <input type="date" className="form-control" id="envet_from_date" placeholder="From Date"/>
                                      <label for="name">From Date</label>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-floating">
                                      <input type="time" className="form-control" id="envet_from_time" placeholder="From time"/>
                                      <label for="name">From Time</label>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-floating">
                                      <input type="date" className="form-control" id="envet_to_date" placeholder="To Date"/>
                                      <label for="name">To Date</label>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-floating">
                                      <input type="time" className="form-control" id="envet_to_time" placeholder="To Time"/>
                                      <label for="name">To Time</label>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="form-floating">
                                    <textarea class="form-control textarea-height" placeholder="Leave a message here" id="envet_message" name="envet_message" maxlength="2000"></textarea>
                                  <label for="name">Message</label>
                                  </div>
                              </div>
                              <div className="col-md-12">
                                  <div className="form-floating">
                                    <input type="file" className="form-control" id="envet_file" placeholder="Add Agenda"/>
                                  <label for="name">Add Agenda</label>
                                  </div>
                              </div>
                              <div className="row g-3">
                                  <div className="col-md-4">
                                    <p className="error_msg_note" id="error_msg"></p>
                                  </div>
                                  <div className="col-md-4">
                                    <p className="error_msg_note"># Form upload, only allow PDF, PNG, JPEG & JPG</p>
                                  </div>
                                  <div className="col-md-4 p-0 float_r">
                                      {this.state.send_button}
                                  </div>
                              </div>

                          </div>
                      </form>
                  </div>
              </div>
              </div>


              </div>
            </div>
          </div>
        </div>


        </>
    );
  }
}

export default NewEventPopup;
